import CustomTitle from '../CustomElements/CustomTitle';
import CustomContainer from '../CustomElements/CustomContainer';
import ConfirmationPage from '../CustomElements/ConfirmationPage';

function BrigadeSafetyFenceRemove({ handlerConfirm, closeModal, t }) {
  return (
    <CustomContainer>
      <CustomTitle titleText={t?.fenceTitle} />
      <ConfirmationPage
        confirmText={t?.removeFenceConfirmText}
        confirmButtonText={t?.confirmButtonText}
        cancelButtonText={t?.cancelButtonText}
        onConfirm={handlerConfirm} // Функция, которая должна быть вызвана при подтверждении
        onCancel={closeModal} // Функция для закрытия модального окна или отмены действия
      />
    </CustomContainer>
  );
}

export default BrigadeSafetyFenceRemove;
